/** Created by azhou on 2019/2/26.*/
<template>
  <div class="d-center-around">
    <rectangle-comp bgColor="#85b0e1" class="text-left">
      <h4 class="mb-2">{{userInfo.type == 2 ? '发布订单' : '我的订单'}}</h4>
      <div v-if="userInfo.type == 3">
        <p class="text-left" v-if="userInfo.type===3" @click="$emit('OrderHandle',userInfo.type,'0')">
          待&ensp;处&ensp;理<span :class="{'text-danger':IndexData.order_arr.wait_handle>0}"> {{IndexData.order_arr.wait_handle}}</span> 个
        </p>
        <p class="text-left" v-if="userInfo.type===3" @click="$emit('goOrderLists',userInfo.type,'1')">
          询&ensp;价&ensp;中<span :class="{'text-danger':IndexData.order_arr.status_4>0}"> {{IndexData.order_arr.status_4}}</span> 个
        </p>
        <p class="text-left" v-if="userInfo.type===3" @click="$emit('goOrderLists',userInfo.type,'today')">
          今日入住<span :class="{'text-danger':IndexData.order_arr.status_today>0}"> {{IndexData.order_arr.status_today}}</span> 个
        </p>
        <p class="text-left" v-if="userInfo.type===3" @click="$emit('goOrderLists',userInfo.type,'stay')">
          入&ensp;住&ensp;中<span :class="{'text-danger':IndexData.order_arr.status_stay>0}"> {{IndexData.order_arr.status_stay}}</span> 个
        </p>
        <p class="text-left" v-if="userInfo.type===3" @click="$emit('goOrderLists',userInfo.type,'all','2')">
          未&ensp;收&ensp;款<span :class="{'text-danger':IndexData.order_arr.wait_pay>0}"> {{IndexData.order_arr.wait_pay}}</span> 个
        </p>
      </div>
      <!-- <p v-if="userInfo.type == 6 || userInfo.type == 5" @click="$emit('goOrderLists',userInfo.type,'14')">
        待确认 <span>{{IndexData.confirm}}</span> 个</p>
      <p v-if="userInfo.type == 5" @click="$emit('goOrderLists',userInfo.type,'8')">
        待收款 <span>{{IndexData.receivable}}</span> 个</p>
      <p v-if="userInfo.type != 2" @click="$emit('goOrderLists',userInfo.type,'9')">
        已完成 <span>{{IndexData.over}}</span> 个</p> -->
      <div v-if="userInfo.type == 2">
        <p>当前用户共发布<span class="text-danger font-weight-bold">{{IndexData.userSendAll}}</span>个订单</p>
        <p>旗下采购商共发布<span class="text-danger font-weight-bold">{{IndexData.storeSendAll}}</span>个订单</p>
      </div>  
    </rectangle-comp>
    <rectangle-comp bgColor="#80c9ce">
      <h4 class="mb-2">用户管理</h4>
      <p @click="$router.push({name:'PositionManage'})">职位数量 <span>{{IndexData.position_arr.position_count}}</span> 个</p>
      <p @click="$router.push({name:'StaffManage'})">人员数量 <span>{{IndexData.position_arr.user_count}}</span> 个</p>
    </rectangle-comp>
    <rectangle-comp bgColor="#f8c26a">
      <h4 class="mb-2">{{userInfo.type == 6 ? '景区管理' :'门店管理'}}</h4>
      <!-- <p @click="$router.push({name:'StoreBasicInfo'})">门店数量 <span>{{IndexData.room_meeting_arr.room_count}}</span> 个</p> -->
    </rectangle-comp>
    <rectangle-comp bgColor="#eb8475" class="cursor-pointer" @click.native="$router.push({name:'AccountSet'})">
      <h4 class="mb-2">账号设置</h4>
    </rectangle-comp>
  </div>
</template>

<script>
  import { mapGetters,mapState } from 'vuex'
  import RectangleComp from './RectangleComp'

  export default {
    name: 'HGroupCenter',
    computed: {
      ...mapState(['IndexData']),
      ...mapGetters(['storeInfo','userInfo'])
    },
    components: { RectangleComp }
  }
</script>
